import { Type } from "@sinclair/typebox";
import { IdSchema } from "./shared.js";
/** 原始目标的稳定需求；规划返工不得删除或改写已登记定义。 */
export const ResearchRequirementDefinitionSchema = Type.Object({
    requirementId: IdSchema,
    requirement: Type.String({ minLength: 1, maxLength: 4000 }),
    kind: Type.Union([Type.Literal("number"), Type.Literal("artifact"), Type.Literal("semantic")]),
}, { additionalProperties: false });
export const ResearchRequirementSchema = Type.Object({
    requirementId: IdSchema,
    requirement: Type.String({ minLength: 1, maxLength: 4000 }),
    status: Type.Union([Type.Literal("met"), Type.Literal("missing")]),
    reason: Type.String({ minLength: 1, maxLength: 4000 }),
    evidence: Type.Array(Type.Object({
        observationId: IdSchema,
        sourcePath: Type.String({ pattern: "^/", maxLength: 4096 }),
        artifactId: Type.Optional(IdSchema),
    }, { additionalProperties: false }), { maxItems: 32 }),
}, { additionalProperties: false });
//# sourceMappingURL=research.js.map